import BaseListagem from "components/BaseListagem";
import Conta from "model/administracao/cadastro/Conta";
import { Column } from "primereact/column";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ContaService from "service/administracao/cadastro/ContaService";
import PerfilService from "service/administracao/cadastro/PerfilService";

const perfilService = new PerfilService();
const contaService = new ContaService();

export default function PerfilListagem() {

    const [queryParameters] = useSearchParams();

    const [conta, setConta] = useState<Conta>(new Conta());
    const [titulo, setTitulo] = useState<string>('Perfis');

    useEffect(() => {

      const idConta = queryParameters.get('idConta');
      if (idConta) {

          contaService.consultar(parseInt(idConta)).then(contaParam => {

              setConta(contaParam);
              setTitulo(`Perfis da Conta ${contaParam.nome}`);
          });

      }

    }, []);

    return (

        <BaseListagem ordenacao="nome,ASC" service={perfilService} urlService="/perfil" tituloPagina={titulo} >
            <Column field="nome" header="Nome" />
        </BaseListagem>
    )
}
